import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

export const gaEvents = {
  CHANGE_ACCOUNT_BUTTON_CLICKED: "CHANGE_ACCOUNT_BUTTON_CLICKED",
  NAVBAR_LOGUT_BUTTON_CLICKED: "NAVBAR_LOGUT_BUTTON_CLICKED",
  LOGIN_WITH_DESO_BUTTON_CLICKED: "LOGIN_WITH_DESO_BUTTON_CLICKED",
  SIGN_UP_WITH_DESO_BUTTON_CLICKED: "SIGN_UP_WITH_DESO_BUTTON_CLICKED",
  PROFILE_SAVE_BUTTON_CLICKED: "PROFILE_SAVE_BUTTON_CLICKED",
  PROFILE_NEXT_BUTTON_CLICKED: "PROFILE_NEXT_BUTTON_CLICKED",
  CHECK_PROFILE_BUTTON_CLICKED: "CHECK_PROFILE_BUTTON_CLICKED",
  CONNECT_SOCIAL_MEDIA_BUTTON_CLICKED_FROM_CHECK_PROFILE:
    "CONNECT_SOCIAL_MEDIA_BUTTON_CLICKED_FROM_CHECK_PROFILE",
  LOGIN_WITH_TWITTER_BUTTON_CLICKED: "LOGIN_WITH_TWITTER_BUTTON_CLICKED",
  TWITTER_SUBSCRIBE_BUTTON_CLICKED: "TWITTER_SUBSCRIBE_BUTTON_CLICKED",
  TWITTER_UNSUBSCRIBE_BUTTON_CLICKED: "TWITTER_UNSUBSCRIBE_BUTTON_CLICKED",
  TWITTER_UNSUBSCRIBE_CONFIRM_BUTTON_CLICKED:
    "TWITTER_UNSUBSCRIBE_CONFIRM_BUTTON_CLICKED",
  TWITTER_UNSUBSCRIBE_CANCEL_BUTTON_CLICKED:
    "TWITTER_UNSUBSCRIBE_CANCEL_BUTTON_CLICKED",
  TWITTER_HASHTAG_INCLUDE_ADD_BUTTON_CLICKED:
    "TWITTER_HASHTAG_ADD_BUTTON_CLICKED",
  TWITTER_HASHTAG_EXCLUDE_ADD_BUTTON_CLICKED:
    "TWITTER_HASHTAG_EXCLUDE_ADD_BUTTON_CLICKED",
  WORDPRESS_UNSUBSCRIBE_BUTTON_CLICKED: "WORDPRESS_UNSUBSCRIBE_BUTTON_CLICKED",
  WORDPRESS_UNSUBSCRIBE_CONFIRM_BUTTON_CLICKED:
    "WORDPRESS_UNSUBSCRIBE_CONFIRM_BUTTON_CLICKED",
  WORDPRESS_UNSUBSCRIBE_CANCEL_BUTTON_CLICKED:
    "WORDPRESS_UNSUBSCRIBE_CANCEL_BUTTON_CLICKED",
  TWITTER_INVITE_BUTTON_CLICKED: "TWITTER_INVITE_BUTTON_CLICKED",
  WORDPRESS_INVITE_BUTTON_CLICKED: "WORDPRESS_INVITE_BUTTON_CLICKED",
  WORDPRESS_HASHTAG_INCLUDE_ADD_BUTTON_CLICKED:
    "WORDPRESS_HASHTAG_INCLUDE_ADD_BUTTON_CLICKED",
  WORDPRESS_HASHTAG_EXCLUDE_ADD_BUTTON_CLICKED:
    "WORDPRESS_HASHTAG_ADD_BUTTON_CLICKED",
  SHARE_ON_TWITTER_BUTTON_CLICKED: "SHARE_ON_TWITTER_BUTTON_CLICKED",
  SEND_ALL_TWEETS_BUTTON_CLICKED: "SEND_ALL_TWEETS_BUTTON_CLICKED",
  SEND_TWEETS_INCLUDING_HASHTAG: "SEND_TWEETS_INCLUDING_HASHTAG",
  SEND_TWEETS_EXCLUDING_HASHTAG: "SEND_TWEETS_EXCLUDING_HASHTAG",
  SEND_ALL_BLOGS: "SEND_ALL_BLOGS",
  SEND_BLOGS_INCLUDING_TAG: "SEND_BLOGS_INCLUDING_HASHTAG",
  SEND_BLOGS_EXCLUDING_TAG: "SEND_BLOGS_EXCLUDING_HASHTAG",
};

export const pushGaEvent = (event) => {
  logEvent(analytics, event);
};
